import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import {
  authResponse,
  loginForm,
  loginResponse,
} from 'src/app/core/models/auth.models';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { interval, Observable } from 'rxjs';
import { DataShareService } from 'src/app/core/services/datashare.sevice';
import { CountdownService } from 'src/app/core/time-interval/time-interval.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})

/**
 * Login component
 */
export class LoginComponent implements OnInit {
  item: any[] = [false, false, false];
  countries;
  // The Account Code tab is hidden. Flip this back to true to restore it -
  // nothing else needs changing, the numbering below adapts.
  showAccountCode = false;
  // Canonical tab numbering used by callResendOtp(), verifyOtp() and
  // onSubmit(): 0 = Account Code, 1 = Email, 2 = Phone. Keep those numbers
  // even when the first tab is hidden, and just start on Email instead.
  tabIndex: number = this.showAccountCode ? 0 : 1;
  loginForm: FormGroup;
  selected_countryid;
  submitted = false;
  loginRespone: loginResponse;
  reTypePassword: string = '';
  filteredOptions: Observable<[]>;
  rememberMe: boolean = false;
  isLoading: boolean = false;
  lastAutoVerifiedOtp: string = '';
  otpResponse: authResponse;
  showPassword: boolean[] = [];
  year: number = new Date().getFullYear();
  @ViewChild('input') input!: ElementRef<HTMLInputElement>;
  public errorMessage;
  public timeToShow;
  public emailphone = '';
  public type = 'agency_id';

  isPasswordChange: boolean = false;
  resendOtpflag: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private storageService: StorageService,
    private authService: AuthenticationService,
    private router: Router,
    private tostrService: ToastService,
    private sharedService: DataShareService,
    private countdownService: CountdownService
  ) { }

  ngOnInit() {
    this.moveFlight();
    this.setAttribute();
    this.formInit();
    this.initializeFormArray();
    this.setItem(0);
    this.initialValues();

  }
  callResendOtp() {
    this.loginForm.get('otp').reset();
    if (this.tabIndex == 0) {
      this.emailphone = this.f['account_code'].value;
    } else if (this.tabIndex == 1) {
      this.emailphone = this.f['email'].value;
    } else {
      this.emailphone = this.f['phone'].value;
    }
    const data = {
      unique_id: this.emailphone,
      password: this.f['password'].value,
      // Same as onSubmit(): read fresh, since this.selected_countryid is
      // captured at init and is undefined on a first visit.
      country_name: this.storageService.getLocalStorageItem('selected_country')?.name,
      type: this.type,
    };
    this.authService.resendOtp(data).subscribe((response: Response) => { });
    (error) => { };
  }
  moveFlight() {
  }

  formInit() {
    const userData = this.storageService.getLocalStorageItem('userDetails');
    this.rememberMe = userData?.isRememberMe;
    this.loginForm = this.formBuilder.nonNullable.group<loginForm>({
      account_code: new FormControl(
        this.rememberMe ? userData?.account_code : ''
      ),
      email: new FormControl(this.rememberMe ? userData?.email : '', [
        Validators.required,
        Validators.email,
      ]),
      phone_code: new FormControl(this.rememberMe ? userData?.email : ''),
      phone: new FormControl(this.rememberMe ? userData?.phone : ''),
      password: new FormControl(this.rememberMe ? userData?.password : '', [
        Validators.required,
      ]),
      otp: this.formBuilder.array([]),
      newPassword: new FormControl('', [Validators.required]),
      reTypePassword: new FormControl('', [Validators.required]),
    });
  }

  initializeFormArray() {
    const otpArray = this.loginForm.get('otp') as FormArray;
    for (let i = 0; i < 6; i++) {
      otpArray.push(this.formBuilder.control(''));
    }
  }
  initialValues() {
    this.selected_countryid =
      this.storageService.getLocalStorageItem('selected_country');
    this.sharedService.counrtyCodeSubject$.subscribe((response: []) => {
      this.countries = response;
    });
  }

  onPaste(event: any) {
    event.preventDefault();
    const pasteData = event.clipboardData.getData('text').replace(/\D/g, '');
    const otpArray = this.loginForm.get('otp') as FormArray;

    for (let i = 0; i < 6; i++) {
      otpArray.at(i).setValue(pasteData[i] || '');
    }
    this.autoVerifyOtp();
  }

  // Calls verify OTP automatically once all digits are entered
  autoVerifyOtp() {
    const otp = this.otpArray.controls.map((control) => control.value).join('');
    if (
      this.isLoading ||
      otp.length != this.otpArray.length ||
      otp === this.lastAutoVerifiedOtp
    ) {
      return;
    }
    this.lastAutoVerifiedOtp = otp;
    this.verifyOtp();
  }

  // ---- OTP boxes ---------------------------------------------------------------
  // Digits are handled on keydown and focus moves synchronously, so fast typing
  // can't outrun it. (It used to move on keyup after a 50ms timeout: a quick next
  // key landed in the box that was already full and maxlength dropped it.)

  private focusOtp(index: number) {
    const el = document.getElementById('otp' + index) as HTMLInputElement | null;
    if (el) {
      el.focus();
      el.select();
    }
  }

  /** Writes digits into the boxes starting at `index`; returns the next index. */
  private fillOtpFrom(index: number, digits: string): number {
    let i = index;
    for (const d of digits) {
      if (i >= this.otpArray.length) break;
      this.otpArray.at(i).setValue(d);
      i++;
    }
    return i;
  }

  onOtpKeydown(event: KeyboardEvent, index: number) {
    const key = event.key;
    const last = this.otpArray.length - 1;

    if (/^[0-9]$/.test(key)) {
      event.preventDefault();
      this.otpArray.at(index).setValue(key);
      if (index < last) {
        this.focusOtp(index + 1);
      } else {
        this.autoVerifyOtp();
      }
      return;
    }

    if (key === 'Backspace') {
      event.preventDefault();
      if (this.otpArray.at(index).value) {
        this.otpArray.at(index).setValue('');
      } else if (index > 0) {
        this.otpArray.at(index - 1).setValue('');
        this.focusOtp(index - 1);
      }
      return;
    }

    if (key === 'Delete') {
      event.preventDefault();
      this.otpArray.at(index).setValue('');
      return;
    }

    if (key === 'ArrowLeft' && index > 0) {
      event.preventDefault();
      this.focusOtp(index - 1);
      return;
    }

    if (key === 'ArrowRight' && index < last) {
      event.preventDefault();
      this.focusOtp(index + 1);
      return;
    }

    // keep Tab, Enter, shortcuts (Ctrl+V ...) working; block other characters
    if (key.length === 1 && !event.ctrlKey && !event.metaKey) {
      event.preventDefault();
    }
  }

  /**
   * Phone keyboards report key "Unidentified" on keydown, and SMS autofill
   * drops the whole code into one box - both arrive here instead.
   */
  onOtpInput(event: Event, index: number) {
    const input = event.target as HTMLInputElement;
    const digits = (input.value || '').replace(/\D/g, '');
    if (!digits) {
      this.otpArray.at(index).setValue('');
      return;
    }
    const next = this.fillOtpFrom(index, digits);
    // the box itself only ever shows one digit
    input.value = this.otpArray.at(index).value;
    if (next <= this.otpArray.length - 1) {
      this.focusOtp(next);
    } else {
      this.focusOtp(this.otpArray.length - 1);
      this.autoVerifyOtp();
    }
  }
  setAttribute() {
    document.body.setAttribute('class', 'authentication-bg');
    document.body.removeAttribute('data-topbar');
  }

  ngOnDestroy() {
    document.body.classList.remove('authentication-bg');
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.loginForm.controls;
  }

  get otpArray(): FormArray {
    return this.loginForm.get('otp') as FormArray;
  }

  changePassword() {
    if (!this.f['newPassword'].value || !this.f['reTypePassword'].value) {
      this.loginForm.get('newPassword').markAsTouched();
      this.loginForm.get('reTypePassword').markAsTouched();
      return;
    }

    this.isLoading = true;
    const data = {
      new_password: this.f['newPassword'].value,
      confirm_password: this.f['reTypePassword'].value,
    };
    this.authService.updatePassword(data).subscribe({
      next: (res) => {
        this.tostrService.success('Password updated successfully', 'OK');
        this.isLoading = false;
        this.router.navigate(['/flight/flight-search']);
      },
      error: (err) => {
        this.tostrService.success(err.error.message, 'Cancel');
        this.isLoading = false;
      },
    });
  }

  togglePassword(type: boolean, index: number) {
    this.showPassword[index] = type;
  }

  selectedTabChange(event: any) {
    // With the Account Code tab hidden, Material reports Email as 0 and Phone
    // as 1. Shift back to the canonical numbering the rest of the flow uses so
    // the payload and validator branches stay correct.
    const index = this.showAccountCode ? event.index : event.index + 1;
    if (index == 0) {
      this.loginForm.get('account_code').setValidators([Validators.required]);
      this.loginForm.get('email').clearValidators();
      this.loginForm.get('phone').clearValidators();
      this.loginForm.get('phone_code').clearValidators();
    } else if (index == 1) {
      this.loginForm.get('email').setValidators([Validators.required]);
      this.loginForm.get('phone').clearValidators();
      this.loginForm.get('phone_code').clearValidators();
    } else if (index == 2) {
      this.loginForm.get('phone_code').setValidators([Validators.required]);
      this.loginForm.get('phone').setValidators([Validators.required]);
      this.loginForm.get('email').clearValidators();
    }
    this.tabIndex = index;
    this.loginForm.get('account_code').updateValueAndValidity();
    this.loginForm.get('phone_code').updateValueAndValidity();
    this.loginForm.get('phone').updateValueAndValidity();
    this.loginForm.get('email').updateValueAndValidity();
  }

  verifyOtp() {
    let otp = '';
    for (let control of this.otpArray.controls) {
      otp += control.value;
    }
    if (otp.length != this.otpArray.length) {
      this.tostrService.error('Please fill otp', 'Cancel');
      return;
    }
    this.isLoading = true;
    if (this.tabIndex == 0) {
      this.emailphone = this.f['account_code'].value;
    } else if (this.tabIndex == 1) {
      this.emailphone = this.f['email'].value;
    } else {
      this.emailphone = this.f['phone'].value;
    }
    const otpData = {
      unique_id: this.emailphone,
      otp: otp,
      type: this.type,
    };
    this.authService.verifyOtp(otpData).subscribe({
      next: (res) => {
        this.otpResponse = res;
        const rememberMe = {
          isRememberMe: this.rememberMe,
          email: this.f['email'].value,
          phone: this.f['phone'].value,
          phone_code: this.f['phone_code'].value,
        };
        if (res?.access_token && res?.refresh_token) {
          const token = {
            access_token: res.access_token,
            refresh_token: res.refresh_token,
          };
          this.storageService.setLocalStorageItem('token', token);
        }
        this.storageService.setLocalStorageItem(
          'permissions',
          res?.permissions
        );

        this.storageService.setLocalStorageItem('user_name', res?.User_Name);
        this.storageService.setLocalStorageItem('role_name', res?.user_role);
        this.storageService.setLocalStorageItem(
          'organization',
          res?.organization
        );
        const data = {
          ...res?.theme,
          selected_image: res?.theme?.profile_picture,
        };
        this.storageService.setLocalStorageItem('themeData', data);
        this.storageService.setLocalStorageItem('button_color', 'red');
        this.isLoading = false;
        this.storageService.setLocalStorageItem('userDetails', rememberMe);
        this.storageService.setLocalStorageItem(
          'proxy',
          res?.show_proxy ? true : false
        );
        this.authService.setValue();
        if (this.loginRespone?.is_first_time) {
          this.setItem(2);
        } else {
          this.router.navigate(['/flight/flight-search']);
        }

        this.tostrService.success('Successfully loggedin.', 'OK');
      },
      error: (err) => {
        this.isLoading = false;
        this.setItem[1];
        this.tostrService.error(err.error.message, 'Cancel');
      },
    });
  }

  setItem(index: number) {
    for (let i = 0; i < this.item.length; i++) {
      if (index === i) {
        this.item[index] = true;
      } else {
        this.item[i] = false;
      }
    }
  }
  otp_required = false;
  onSubmit() {
    if (
      (!this.f['account_code'].value && this.tabIndex == 0) ||
      (!this.f['email'].value && this.tabIndex == 1) ||
      !this.f['password'].value ||
      ((!this.f['phone_code'].value || !this.f['phone'].value) &&
        this.tabIndex == 2) ||
      this.loginForm.get('password').invalid
    ) {
      this.loginForm.get('email').markAsTouched();
      this.loginForm.get('password').markAsTouched();
      this.loginForm.get('phone_code').markAsTouched();
      this.loginForm.get('phone').markAsTouched();
      this.loginForm.get('account_code').markAsTouched();
      return;
    }

    this.isLoading = true;
    const selected_country =
      this.storageService.getLocalStorageItem('selected_country');
    if (this.tabIndex == 0) {
      this.emailphone = this.f['account_code'].value;
    } else if (this.tabIndex == 1) {
      this.emailphone = this.f['email'].value;
      this.type = 'email';
    } else {
      this.emailphone = this.f['phone'].value;
      this.type = 'phone';
    }

    const authCredentials = {
      unique_id: this.emailphone,
      password: this.f['password'].value,
      // Read from the fresh copy above, not this.selected_countryid: that is
      // captured once in initialValues() and is still empty on a first visit,
      // where `.name` on it throws before the request is ever sent.
      country_name: selected_country?.name,
      type: this.type,
      country_code:
        this.tabIndex == 2
          ? this.f['phone_code'].value
          : selected_country?.calling_code,
    };
    this.authService.login(authCredentials).subscribe({
      next: (res: any) => {
        if (res) {
          this.loginRespone = res;
          this.otp_required = res?.otp_required;
          if (this.otp_required) this.setItem(1);
          else {
            let requestBody = { token: res?.token };
            this.userLoginWithoutOtp(requestBody);
          }
          this.isLoading = false;
          this.storageService.setLocalStorageItem(
            'proxy',
            res?.show_proxy ? true : false
          );
          this.storageService.setLocalStorageItem('whitelabel', res?.is_whitelabel ? true : false);
          this.startTimer();
          this.timeToShow = '00:30';
        }
      },
      error: (err) => {
        if (err.status == 410) this.errorMessage = err.error.message;
        else {
          this.errorMessage = '';
          this.tostrService.error(err.error.message, 'Cancel');
        }
        this.setItem(0);
        this.isLoading = false;
      },
    });
  }
  filter(): void {
    const filterValue = this.input.nativeElement.value.toLowerCase();
    this.filteredOptions = this.countries?.filter((country: any) => {
      const filterValueLower = filterValue?.toLowerCase(); // Convert filterValue to lowercase
      const nameLower = country.country_name?.toLowerCase(); // Convert country name to lowercase for case-insensitive comparison
      const codeLower = country.country_code?.toLowerCase(); // Convert country code to lowercase for case-insensitive comparison
      return (
        nameLower.includes(filterValueLower) ||
        country.country_code.includes(filterValue) || // Assuming dial_code is a string
        codeLower.includes(filterValueLower)
      );
    });
  }
  startTimer() {
    this.countdownService.startCountdown(30); // Start a 6-seconds countdown
    interval(1000).subscribe(() => {
      this.timeToShow = this.countdownService.getRemainingTime();
      if (this.timeToShow === '0:00') this.resendOtpflag = true;
    });
  }
  userLoginWithoutOtp(otpData) {
    this.authService.verifyUser(otpData).subscribe({
      next: (res: any) => {
        this.otpResponse = res;
        const rememberMe = {
          isRememberMe: this.rememberMe,
          email: this.f['email'].value,
          phone: this.f['phone'].value,
          phone_code: this.f['phone_code'].value,
        };
        if (res?.access_token && res?.refresh_token) {
          const token = {
            access_token: res.access_token,
            refresh_token: res.refresh_token,
          };
          this.storageService.setLocalStorageItem('token', token);
        }
        this.storageService.setLocalStorageItem(
          'permissions',
          res?.permissions
        );
        const data = {
          ...res?.theme,
          selected_image: res?.theme?.profile_picture,
        };
        this.storageService.setLocalStorageItem('themeData', data);

        this.storageService.setLocalStorageItem('user_name', res?.User_Name);
        this.storageService.setLocalStorageItem('role_name', res?.user_role);
        this.storageService.setLocalStorageItem('button_color', 'red');
        this.isLoading = false;
        this.storageService.setLocalStorageItem('userDetails', rememberMe);
        this.storageService.setLocalStorageItem('proxy', res?.show_proxy ? true : false);
        this.storageService.setLocalStorageItem('organization', res?.organization);
        this.authService.setValue();
        if (this.loginRespone?.is_first_time) {
          this.setItem(2);
        } else {
          this.router.navigate(['/flight/flight-search']);
        }

        this.tostrService.success('Successfully loggedin.', 'OK');
      },
      error: (err) => {
        this.isLoading = false;
        this.setItem[1];
        this.tostrService.error(err.error.message, 'Cancel');
      },
    });
  }
}
